<template>
    <div style="padding: 20px">
        <!-- keyscan -->
        <Keypress :multiple-keys="multiple" key-event="keyup" @success="checkselfScan" @wrong="otherMethod" />
        <!-- content -->
        <div class="mb-0 text-center">
            <img class="logo-size" src="../../../public/images/logo_muic.png" alt="imag_eventscan_1" />
        </div>
        <a-card style="border-radius: 10px;" bordered class="mt-50 mb-20">
            <template slot="title">

                <p style="font-size: 32px;color: #000000;" class="mt-0 mb-0 font-web font-weight-bold">Check-in : {{ getTokenUrl }}</p>
                <p style="font-size: 28px;color: red;" class="mt-1 mb-5 font-en text-danger font-web">
                    *** For MUIC graduates only ***
                </p>

            </template>

            <div slot="extra">
                <a @click="clearDataObj" target="_blank" rel="noopener noreferrer"><a-icon style="font-size: 20px;" class="font-web font-weight-bold" type="redo" /></a>
            </div>

            <!-- 
                user_code: "MUIC ID",
                bachelor: "-",
                major_th: "-",
                major_en: "-",
                present_order: "",
                title_th: "",
                name_th: "",
                title_en: "-",
                name_en: "-",
                form_survey: "-",
                practise: "-",
                std_group: "-",
                msg: "-",
                remark: "-",
                created_at: "-",
            -->

            <a-card-grid style="width:50%;text-align:center">
                
                
                <img v-if="['-'].includes(objSelfCheck.picture)" src="../../../public/images/avatar.png" alt="imag_eventscan_2" />
                <img
                    v-else
                    style="top: 20px;"
                    alt="imag_eventscan_3"
                    :src="`${objSelfCheck.picture}`"
                />
                <a-card-meta class="mt-20 mb-30">
                    <template slot="title">
                        <h3 class="mt-0 mb-0 font-web font-weight-bold">
                            {{ `${objSelfCheck.title_en} ${objSelfCheck.name_en}` }} , {{ !['','null',null].includes(valKey) ? valKey : objSelfCheck.user_code }}
                        </h3>
                        
                    </template>
                    <template slot="description">
                        <p style="font-size: 22px;" class="font-web mt-0 mb-0">{{ objSelfCheck.major_en }}</p>
                    </template>
                </a-card-meta>

                <br>
                

            </a-card-grid>
            <a-card-grid style="width:50%;text-align:left;min-height: 550px;">

                <a-descriptions
                    class="mt-20 mb-20"
                    title="Graduate details:"
                    bordered
                    size="middle"
                    :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }"
                >
                    <a-descriptions-item :span="5">
                        <div slot="label">
                            <h4 class="font-web mt-0 mb-0">Graduation Number:</h4>
                        </div>
                        <div class="text-right">
                            <h3 style="color: #000000;" class="font-weight-bold font-web mt-0 mb-0">{{ objSelfCheck.present_order }}</h3>
                        </div>
                    </a-descriptions-item>
                    <a-descriptions-item v-if="objSelfCheck.form_survey" :span="5">
                        <div slot="label">
                            <h4 class="font-web mt-0 mb-0">Graduation Schedule:</h4>
                        </div>
                        <div class="text-right">
                            <div style="margin-bottom: 10px;" v-if="Number(objSelfCheck.present_order) >= 5450 && Number(objSelfCheck.present_order) <= 5819">
                                <h4 class="mt-0 mb-10 font-web" style="text-decoration: underline;">Rehearsal Group 1</h4>
                                <div style="text-align: right;">
                                    <h5 class="mt-0 mb-1"><small style="font-size: 14px;">First Rehearsal: </small><span class="text-danger">Thursday, October 1, 2026* (8:00 A.M.)</span></h5>
                                    <h6 class="mt-0 mb-1"><small style="font-size: 14px;">Grand Rehearsal: </small><span class="text-danger">Saturday, October 3, 2026 (1:30 P.M.)</span></h6>
                                    <h6 class="mt-0 mb-0"><small style="font-size: 14px;">Commencement Ceremony: </small><span class="text-danger">Tuesday, October 6, 2026 (9:30 A.M.)</span></h6>
                                </div>
                            </div>

                            <div v-if="Number(objSelfCheck.present_order) >= 5820 && Number(objSelfCheck.present_order) <= 6242">
                                <h4 class="mt-0 mb-10 font-web" style="text-decoration: underline;">Rehearsal Group 2</h4>
                                <div style="text-align: right;">
                                    <h5 class="mt-0 mb-1"><small style="font-size: 14px;">First Rehearsal: </small><span class="text-danger">Friday, October 2, 2026* (8:00 A.M.)</span></h5>
                                    <h6 class="mt-0 mb-1"><small style="font-size: 14px;">Grand Rehearsal: </small><span class="text-danger">Saturday, October 3, 2026 (1:30 P.M.)</span></h6>
                                    <h6 class="mt-0 mb-0"><small style="font-size: 14px;">Commencement Ceremony: </small><span class="text-danger">Tuesday, October 6, 2026 (9:30 A.M.)</span></h6>
                                </div>
                            </div>
                        </div>
                    </a-descriptions-item>
                    <a-descriptions-item :span="5">
                        <div slot="label">
                            <h4 class="font-web mt-0 mb-0">Employment Survey Status:</h4>
                        </div>
                        <div :style="{ zIndex: -999, backgroundColor: `${ objSelfCheck.form_survey ? '#00BBA7' : '#FF0000'}`, padding: '15px' , borderRadius: '10px' }" class="text-right">
                            <p style="font-size: 30px;z-index: 999;" class="text-white font-web mt-0 mb-0">{{ objSelfCheck.form_survey ? "Done" : "Not Done" }}</p>
                        </div>
                    </a-descriptions-item>
                    <a-descriptions-item :span="5">
                        <div slot="label">
                            <h4 class="font-web mt-0 mb-0">Time Check-in:</h4>
                        </div>
                        <div class="text-right">
                            <h5 class="font-web mt-0 mb-0">{{ !['','-',null].includes(objSelfCheck.created_at) ? moment(objSelfCheck.created_at).format("LTS") : '' }}</h5>
                        </div>
                    </a-descriptions-item>
                    <a-descriptions-item v-if="msgerror" :span="5">
                        <div slot="label">
                            <h4 class="font-web mt-0 mb-0">Not Found :</h4>
                        </div>
                        <div class="text-center">
                            <h4 class="text-muted font-web mt-0 mb-0"><i>โปรดตรวจสอบรายชื่อ</i></h4>
                        </div>
                    </a-descriptions-item>
                </a-descriptions>
                
            </a-card-grid>
        </a-card>
    </div>
</template>


<script>
import moment from 'moment';

export default {
    components: {
        Keypress: () => import("vue-keypress"),
    },
    data() {
        return {
            msgerror: false,
            loadADD: false,
            valKey: "",
            valKeyInput: "",
            valTemp: "Key name",
            multiple: [
                {
                    keyCode: 13, // Enter
                    modifiers: [],
                    preventDefault: true,
                },
            ],
            addNewID: "",
            objSelfCheck: {
                user_code: "MUIC ID",
                bachelor: "-",
                major_th: "-",
                major_en: "-",
                present_order: "",
                title_th: "",
                name_th: "",
                title_en: "-",
                name_en: "-",
                form_survey: false,
                practise: "-",
                std_group: "-",
                msg: "-",
                remark: "-",
                created_at: "-",
                picture: "-",
            },
        }
    },
    computed: {
        getTokenUrl() {
            return this.$route.query.location === undefined ||
                this.$route.query.location === ""
                ? "Not spectify location"
                : this.$route.query.location;
        },
    },
    mounted() { },
    methods: {
        clearDataObj() {
            this.msgerror = false
            this.valKey = "";
            this.valKeyInput = "";
            this.objSelfCheck = Object.assign({}, {
                user_code: "MUIC ID",
                bachelor: "-",
                major_th: "-",
                major_en: "-",
                present_order: "",
                title_th: "",
                name_th: "",
                title_en: "-",
                name_en: "-",
                form_survey: false,
                practise: "-",
                std_group: "-",
                msg: "-",
                remark: "-",
                created_at: "-",
                picture: "-",
            });
        },
        otherMethod(response) {
            if (response.event.keyCode >= 48 && response.event.keyCode <= 57) {
                let temp = response.event.keyCode - 48;
                this.valKey += `${temp}`;
            } else if (
                response.event.keyCode >= 96 &&
                response.event.keyCode <= 105
            ) {
                let temp = response.event.keyCode - 96;
                this.valKey += `${temp}`;
            } else if (
                response.event.keyCode === 8 ||
                response.event.keyCode === 46
            ) {
                this.valKey = this.valKey.substring(0, this.valKey.length - 1);
            } else if (response.event.keyCode == 188) {
                this.valKey = this.valKey + ",";
            }
        },
        async checkselfScan(response) {
            this.msgerror = false
            this.objSelfCheck = Object.assign({}, {
                user_code: "MUIC ID",
                bachelor: "-",
                major_th: "-",
                major_en: "-",
                present_order: "",
                title_th: "",
                name_th: "",
                title_en: "-",
                name_en: "-",
                form_survey: false,
                practise: "-",
                std_group: "-",
                msg: "-",
                remark: "-",
                created_at: "-",
                picture: "-",
            });
            try {
                this.valKeyInput = this.valKey;
                const resSCAN = await this.$http.get(
                    `/graduate-atk/profile/${this.valKey}/check/?location=${this.getTokenUrl}`
                );
                this.valKey = "";
                this.valKeyInput = "";
                if (resSCAN.status === 200) {
                    this.objSelfCheck.user_code = resSCAN.data.code_id_detail.user_code
                    this.objSelfCheck.bachelor = resSCAN.data.code_id_detail.bachelor
                    this.objSelfCheck.major_th = resSCAN.data.code_id_detail.major_th
                    this.objSelfCheck.major_en = resSCAN.data.code_id_detail.major_en
                    this.objSelfCheck.present_order = resSCAN.data.code_id_detail.present_order
                    this.objSelfCheck.title_th = resSCAN.data.code_id_detail.title_th
                    this.objSelfCheck.name_th = resSCAN.data.code_id_detail.name_th
                    this.objSelfCheck.title_en = resSCAN.data.code_id_detail.title_en
                    this.objSelfCheck.name_en = resSCAN.data.code_id_detail.name_en
                    this.objSelfCheck.form_survey = resSCAN.data.code_id_detail.form_survey
                    this.objSelfCheck.practise = resSCAN.data.code_id_detail.practise
                    this.objSelfCheck.std_group = resSCAN.data.code_id_detail.std_group
                    this.objSelfCheck.msg = resSCAN.data.code_id_detail.msg
                    this.objSelfCheck.remark = resSCAN.data.code_id_detail.remark
                    this.objSelfCheck.created_at = resSCAN.data.created_at
                    this.objSelfCheck.picture = `https://icapp.muic.mahidol.ac.th/source/pic/${resSCAN.data.code_id_detail.user_code}.jpg`
                } else if (resSCAN.status === 204) {
                    this.msgerror = true
                }
            } catch (error) {
                this.msgerror = true;
            }
            // clear
            setTimeout(() => this.clearDataObj(), 5000);
        },
        getLabel(number) {
            if (number >= 1840 && number <= 2326) {
                return "Friday, October 3, 2025 (08:00–16:00 hrs.)";
            } else if (number >= 2327 && number <= 2751) {
                return "Saturday, October 4, 2025 (08:00–16:00 hrs.)";
            } else {
                return "-"; // ถ้าไม่อยู่ในช่วงที่กำหนด
            }
        }
    },
} 
</script>

<style scoped>
    .logo-size {
        width: 500px;
        height: 100%;
        margin-top: 10px;
        z-index: -999;
    }
</style>

<style>
    /* .ant-descriptions-item-content{
        background-color: aquamarine !important;
    } */
</style>